import { IFooterLocale } from '@/interfaces/staticlocale';
import React, { ReactElement, createRef, useEffect, useState } from 'react';
import './style.scss';
import { addOrRemoveClass } from '@/shared/helpers';
import { basesUrl } from '@/lib/BasesUrl';

interface Props {
  footerLocale: IFooterLocale;
  pathLang: string;
}

export const TermsAndPrivacy = ({
  footerLocale,
  pathLang,
}: Props): ReactElement => {
  let cookieName = 'cookieAcceptance';
  const [showTerms, setShowTerms] = useState(true);
  const termsRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (document !== undefined && !document.cookie.includes(cookieName)) {
      if (termsRef.current) {
        setShowTerms(true);
        termsRef.current!.classList.add('show');
      }
    } else {
      setShowTerms(false);
    }
  }, []);

  const handleSetTermsCookie = () => {
    let expDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 1);
    let cookie = `${cookieName}=true;SameSite=lax;Expires=${expDate.toUTCString()}`;

    const handleAnimationEnd = () => {
      setShowTerms(false);
      termsRef.current?.removeEventListener(
        'transitionend',
        handleAnimationEnd
      );
    };

    document.cookie = cookie;
    if (termsRef.current) {
      termsRef.current.classList.remove('show');
      termsRef.current.addEventListener('transitionend', handleAnimationEnd);
    }
  };

  if (showTerms) {
    return (
      <section
        id="termsAndPrivacy"
        className="typ-1 terms-privacy"
        ref={termsRef}
      >
        <section className="default-screen-size terms-privacy-content">
          <p>
            {footerLocale.cookie_request}{' '}
            <a href={`/${pathLang}${basesUrl.termsOfUse}`}>
              <strong>{footerLocale.terms_of_use}</strong>
            </a>{' '}
            {footerLocale.and}{' '}
            <a href={`/${pathLang}${basesUrl.privacyPolicies}`}>
              <strong>{footerLocale.privacy_policy}</strong>
            </a>
          </p>
          <button onClick={handleSetTermsCookie} id="handleTermsAndPrivacy">
            {footerLocale.proceed}
          </button>
        </section>
      </section>
    );
  }

  return <></>;
};
